import React from 'react';

/**
 * Parses simple inline markdown bold syntax (**text**) into React elements.
 * Returns the text as-is if no bold patterns are present.
 *
 * @param {string} text - The input text containing optional **bold** segments.
 * @returns {React.ReactNode}
 */
export function renderFormattedText(text) {
  if (typeof text !== 'string') return text;

  const parts = text.split(/(\*\*.*?\*\*)/g);
  if (parts.length === 1) return text;

  return parts.map((part, index) =>
    part.startsWith('**') && part.endsWith('**') ? (
      <span key={index} className="font-bold">
        {part.slice(2, -2)}
      </span>
    ) : (
      part
    )
  );
}
